import React, { ReactElement } from 'react'
import { shortenAddress } from '@/utils/shortenAddress'
import { formatDateString } from '@/utils/formatting'
import { Transaction } from '@/database/transaction'
import { TransactionStatus } from '@/database/types'

const HistoryBuy = ({ transaction }: { transaction: Transaction }): ReactElement => {
    return (
        <ul>
            <span className="white">
                {transaction.status !== TransactionStatus.TRANSFERRED ? `${transaction.status} ` : ''}
                {transaction.type}&nbsp;
            </span>
            <span className={'white'}>{transaction.amount}</span>
            <span className="gray">&nbsp;by&nbsp;</span>
            <span className={'light-gray'}>{shortenAddress(transaction.sender)}&nbsp;</span>
            <span className="gray">&nbsp;from&nbsp;</span>
            <span className={'light-gray'}>{shortenAddress(transaction.owner)}&nbsp;</span>
            <span className="gray">&nbsp;at&nbsp;</span>
            <span className={'light-gray'}>{formatDateString(transaction.createdAt)}&nbsp;</span>
        </ul>
    )
}

export default HistoryBuy
